import { render, staticRenderFns } from "./lessonStatSummary.vue?vue&type=template&id=5faaebc0&scoped=true&lang=html&"
import script from "./lessonStatSummary.vue?vue&type=script&lang=ts&"
export * from "./lessonStatSummary.vue?vue&type=script&lang=ts&"
import style0 from "./lessonStatSummary.vue?vue&type=style&index=0&id=5faaebc0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faaebc0",
  null
  
)

export default component.exports